import React from 'react'
import { SupportStaffProvider } from '../../supportStaff'
import AdminBillingPage from './AdminBillingPage'

const AdminBillingRoute = () => (
  <SupportStaffProvider>
    <AdminBillingPage />
  </SupportStaffProvider>
)

export default AdminBillingRoute
